import React from 'react'

import clsx from 'clsx'

import InfoCircleTooltip from 'components/InfoCircleTooltip'
import Rating from 'components/Rating'
import Typography from 'components/Typography'

import { roundToOneDecimal } from '../../helpers'
import DeltaChange from '../DeltaChange'
import PricingDetails from '../PricingDetails'
import ProductTag from '../ProductTag'
import TopFeatures from '../TopFeatures'

import classes from './MobileContent.module.scss'

const MobileContent = ({ listing, alternative }) => {
  const listingHasReviews = listing.num_reviews > 0

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <div className={classes.left}>
          <ProductTag listing={alternative} />
        </div>
        <div className={classes.right}>
          <ProductTag listing={listing} className={classes.productVersus} />
        </div>
      </div>
      {/* Value for money */}
      <div className={classes.row}>
        <div className={classes.merged}>
          <Typography variant="heading-xs" className={classes.sectionTitle}>
            Value for money
          </Typography>
        </div>
        <div className={clsx(classes.left, classes.ratingContainer)}>
          {listingHasReviews && (
            <DeltaChange
              className={classes.deltaChange}
              listingRating={roundToOneDecimal(listing.by_field.rating_value)}
              alternativeRating={roundToOneDecimal(alternative.by_field.rating_value)}
            />
          )}
          <Rating.Base average={alternative.by_field.rating_value} isCompact size="small" className={classes.rating} />
        </div>
        <div className={classes.right}>
          <Rating.Base average={listing.by_field.rating_value} isCompact size="small" className={classes.rating} />
        </div>
      </div>
      {/* Starting price */}
      <div className={classes.row}>
        <div className={classes.merged}>
          <InfoCircleTooltip
            className={classes.infoCircle}
            label={<Typography variant="heading-xs">Starting price</Typography>}
            title="Prices may vary depending on the number of users and features."
          />
        </div>
        <div className={classes.left}>
          <PricingDetails pricing={alternative.pricing} align="right" />
        </div>
        <div className={classes.right}>
          <PricingDetails pricing={listing.pricing} align="left" />
        </div>
      </div>

      {/* Functionality */}
      <div className={classes.row}>
        <div className={classes.merged}>
          <Typography variant="heading-xs" className={classes.sectionTitle}>
            Functionality
          </Typography>
        </div>
        <div className={clsx(classes.left, classes.ratingContainer)}>
          {listingHasReviews && (
            <DeltaChange
              className={classes.deltaChange}
              listingRating={roundToOneDecimal(listing.by_field.rating_features)}
              alternativeRating={roundToOneDecimal(alternative.by_field.rating_features)}
            />
          )}
          <Rating.Base
            average={alternative.by_field.rating_features}
            isCompact
            size="small"
            className={classes.rating}
          />
        </div>
        <div className={classes.right}>
          <Rating.Base average={listing.by_field.rating_features} isCompact size="small" className={classes.rating} />
        </div>
      </div>
      {/* Top features */}
      <div className={classes.row}>
        <div className={classes.merged}>
          <Typography variant="heading-xs" className={classes.sectionTitle}>
            Top features
          </Typography>
        </div>
        <div className={classes.left}>
          <TopFeatures listing={alternative} uniqueFeatures={alternative.features.unique.alt} align="right" />
        </div>
        <div className={classes.right}>
          <TopFeatures listing={listing} uniqueFeatures={alternative.features.unique.main} align="left" />
        </div>
      </div>
    </div>
  )
}
export default MobileContent
